/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb3_NoteInputs */

const en_visa_eb3_note = /** @type {(inputs: Visa_Eb3_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note: Many EB-3 matters involve PERM labor certification and close coordination with the sponsoring employer.`)
};

const pt_visa_eb3_note = /** @type {(inputs: Visa_Eb3_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota: Muitos casos EB-3 envolvem certificação trabalhista PERM e coordenação próxima com o empregador patrocinador.`)
};

const es_visa_eb3_note = /** @type {(inputs: Visa_Eb3_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota: Muchos casos EB-3 implican certificación laboral PERM y estrecha coordinación con el empleador patrocinador.`)
};

/**
* | output |
* | --- |
* | "Note: Many EB-3 matters involve PERM labor certification and close coordination with the sponsoring employer." |
*
* @param {Visa_Eb3_NoteInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb3_note = /** @type {((inputs?: Visa_Eb3_NoteInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb3_NoteInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb3_note(inputs)
	if (locale === "es") return es_visa_eb3_note(inputs)
	return en_visa_eb3_note(inputs)
});